export const LEGAL_TERMS_CHECKBOX = "product-legal-terms";
export const LEGAL_TERMS_ERROR_MESSAGE = LEGAL_TERMS_CHECKBOX + "-error";